import React, { useEffect } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useSelector, AppDispatch } from "../../store";
import { setResData, setId, setDispSw, setLoad } from "./popupSlice";

const PopupTxt: React.FC<{ clickTxt: any }> = ({ clickTxt }) => {
  const auth: any = useSelector((state) => state.authentication);
  const res_data: any = useSelector((state) => state.popupData.res_data);
  const save_id: string = useSelector((state) => state.popupData.save_id);
  const disp_sw: boolean = useSelector((state) => state.popupData.disp_sw);
  const loadState: boolean = useSelector((state) => state.popupData.loadState);
  const dispatch: AppDispatch = useDispatch();
  const viewState: Number = useSelector((state) => state.viewData.viewState);

  useEffect(() => {
    const getPopup = async (): Promise<void> => {
      const headers: any = {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        Authorization: auth.data.res_data.token,
      };

      await axios
        .request({
          url: `${process.env.REACT_APP_API_URL}api/api0009`,
          method: "GET",
          headers: headers,
          params: {
            consumer_id: auth.data.res_data.consumer_id,
            retailer_id: auth.data.res_data.retailer_id,
          },
        })
        .then((response) => {
          dispatch(setResData({ res_data: response.data.res_data }));
          dispatch(setLoad({ loadState: true }));

          if (save_id !== response.data.res_data.popup_id) {
            dispatch(setDispSw({ disp_sw: true }));
            dispatch(setId({ popup_id: response.data.res_data.popup_id }));
          }
        })
        .catch((error) => {
          console.log(error);
          dispatch(setLoad({ loadState: true }));
        });
    };

    getPopup();
  }, [auth]);

  const fncClose = () => {
    dispatch(setDispSw({ disp_sw: false }));
  };

  if (!loadState) {
    return <></>;
  }
  if (disp_sw === false) {
    return <></>;
  }
  if (res_data.popup_text === undefined) {
    return <></>;
  }

  let clk1 = clickTxt;
  if (res_data.transition_url === "") {
    clk1 = () => {};
  }
  const popuptyle = {
    margin: "5px 20px",
  };

  const textStyle = {
    fontWeight: "bold",
    color: "red",
  };

  const lineStyle = () => {
    const lineTop = { borderTop: "2px solid #707070" };
    const lineTBottom = { borderBottom: "2px solid #707070" };

    if (viewState === 0) {
      return lineTop;
    } else {
      return { ...lineTop, ...lineTBottom };
    }
  };

  return (
    <>
      <div style={lineStyle()}>
        <div className="flex justify-between" style={popuptyle}>
          <div onClick={clk1} style={textStyle}>
            {res_data.popup_text}
          </div>
          <div className="w-5" onClick={fncClose}>
            <img src="img/exit.png" />
          </div>
        </div>
      </div>
    </>
  );
};

export const PopupUrl: React.FC = () => {
  const iframeRef = React.createRef<HTMLIFrameElement>();
  const res_data: any = useSelector((state) => state.popupData.res_data);
  return (
    <>
      <div className="faqIframe">
        <iframe ref={iframeRef} src={res_data.transition_url} />
      </div>
    </>
  );
};

export default PopupTxt;
